import {ButtonTypography, ButtonVariant} from "@/components/button/Button.types.ts";
import {ReactElement} from "react";

export const NAV_TABS_VARIANTS = [
  "default",
  "marketing",
  "pagespeed",
  "header",
  "statuspage",
  "statuspageContent",
] as const;

export type NavTabsVariant = (typeof NAV_TABS_VARIANTS)[number];

export const NavTabsButtonVariant: Record<NavTabsVariant, ButtonVariant> = {
  default: "navTabsButton",
  marketing: "navTabsMarketingButton",
  pagespeed: "navTabsPagespeedButton",
  header: "navTabsButton",
  statuspage: "navTabsButton",
  statuspageContent: "navTabsButton",
};

export const NavTabsButtonTypography: Record<NavTabsVariant, ButtonTypography[]> = {
  default: ["link", "linkBold"],
  marketing: ["marketingLinkTiny", "marketingLinkTinyBold"],
  pagespeed: ["link", "linkBold"],
  header: ["link", "linkBold"],
  statuspage: ["linkBold", "linkBold"],
  statuspageContent: ["link", "linkBold"],
};

export interface NavTabItem {
  id: string;
  title: string | ReactElement;
  badgeText?: string | number;
  error?: boolean;
}

export interface NavTabsProps {
  className?: string;
  items: NavTabItem[];
  selectedId: string;
  selectTab: (tab: string) => void;
  variant?: NavTabsVariant;
}
